var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-signin"},[_c('div',{ref:"btn",staticClass:"google-signin-btn"}),(_vm.statusMessage)?_c('p',{staticClass:"google-signin-warn"},[_vm._v("\n    "+_vm._s(_vm.statusMessage)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }